import {
  Action,
  combineReducers,
  configureStore,
  ThunkAction,
} from "@reduxjs/toolkit";
import loginReducer from "../screens/login/loginSlice";
import auditLogReducer from "../screens/AuditLogs/auditLogsSlice";
import errorLogReducer from "../screens/ErrorLogs/errorLogsSlice";
import systemReducer from "../screens/systemSlice";
import deploymentsReducer from "../screens/Deployments/deploymentsSlice";
import deploymentMetricsReducer from "../screens/Deployments/deploymentMetricsSlice";
import listWarningsReducer from "../screens/Warnings/listWarningsSlice";
import deleteWarningReducer from "../screens/Warnings/deleteWarningSlice";
import deploymentPrometheusMetricsReducer from "../screens/Deployments/deploymentPrometheusMetricsSlice";
import sessionReducer from "../screens/login/sessionSlice";
import traceReducer from "../screens/Deployments/Trace/traceSlice";
import healingReducer from "../screens/Observability/Healing/healingSlice";
import dataMapReducer from "../screens/DataMap/dataMapSlice";
import detailsSectionReducer from "../screens/Deployments/detailsSectionSlice";
import catalogReducer from "../screens/Catalog/catalogSlice";
import singleGraphMetricsReducer from "../screens/Deployments/singleGraphMetricsSlice";
import nodesReducer from "../screens/Nodes/nodesSlice";
import firewallReducer from "../screens/Firewall/firewallSlice";
import kmsReducer from "screens/KMS/kmsSlice";
import identityProvidersReducer from "screens/IdentityProviders/identityProvidersSlice";
import usersReducer from "screens/Users/usersSlice";
import rolesReducer from "screens/Roles/rolesSlice";
import licenseReducer from "screens/License/licenseSlice";
import tenantsReducer from "../screens/Tenants/tenantsSlice";
import createTenantReducer from "../screens/Tenants/AddTenant/createTenantSlice";
import addPoolReducer from "../screens/Tenants/TenantDetails/Pools/AddPool/addPoolSlice";
import editPoolReducer from "../screens/Tenants/TenantDetails/Pools/EditPool/editPoolSlice";
import editTenantSecurityContextReducer from "../screens/Tenants/tenantSecurityContextSlice";
import installOperatorOptionsReducer from "../screens/Sites/Operator/operatorSlice";
import addObserveReducer from "../screens/Observability/AddObserve/addObserveSlice";
import observeReducer from "../screens/Observability/Details/observeDetailsSlice";
import addIngressReducer from "../screens/Ingress/AddIngress/addIngressSlice";
import setupReducer from "../screens/Setup/setupSlice";
import addCatalogReducer from "../screens/Catalog/AddCatalog/addCatalogSlice";
import addFirewallReducer from "../screens/Firewall/AddFirewall/addFirewallSlice";
import addKMSReducer from "../screens/KMS/AddKMS/addKMSSlice";
import listIngressReducer from "../screens/Ingress/ingressListSlice";
import ingressDetailsReducer from "../screens/Ingress/IngressDetails/ingressDetailsSlice";
import tenantCacheSlice from "../screens/Tenants/TenantDetails/Cache/cacheSlice";
import consoleReducer from "../screens/Console/consoleSlice";
import consoleSystemReducer from "../screens/Console/systemSlice";
import objectBrowserReducer from "../screens/Console/ObjectBrowser/objectBrowserSlice";
import bucketDetailsReducer from "../screens/Console/Buckets/BucketDetails/bucketDetailsSlice";
import addBucketsReducer from "../screens/Console/Buckets/ListBuckets/AddBucket/addBucketsSlice";
import createUserReducer from "../screens/Console/Users/AddUsersSlice";
import destinationSlice from "../screens/Console/EventDestinations/destinationsSlice";
import { objectBrowserWSMiddleware } from "screens/Console/websockets/objectBrowserWSMiddleware";

let objectsWS: WebSocket;

const rootReducer = combineReducers({
  system: systemReducer,
  login: loginReducer,
  setup: setupReducer,
  audit: auditLogReducer,
  error: errorLogReducer,
  deployments: deploymentsReducer,
  deploymentMetrics: deploymentMetricsReducer,
  listWarnings: listWarningsReducer,
  deleteWarning: deleteWarningReducer,
  deploymentPrometheusMetrics: deploymentPrometheusMetricsReducer,
  session: sessionReducer,
  trace: traceReducer,
  dataMap: dataMapReducer,
  detailsSection: detailsSectionReducer,
  catalog: catalogReducer,
  singleGraphMetrics: singleGraphMetricsReducer,
  firewall: firewallReducer,
  nodes: nodesReducer,
  kms: kmsReducer,
  identityProviders: identityProvidersReducer,
  users: usersReducer,
  roles: rolesReducer,
  license: licenseReducer,
  // Operator Reducers
  tenants: tenantsReducer,
  createTenant: createTenantReducer,
  addPool: addPoolReducer,
  editPool: editPoolReducer,
  editTenantSecurityContext: editTenantSecurityContextReducer,
  installOperatorOptions: installOperatorOptionsReducer,
  healing: healingReducer,
  // Observe Reducers
  addObserve: addObserveReducer,
  observe: observeReducer,
  // Catalog Reducers
  addCatalog: addCatalogReducer,
  // Firewall Reducers
  addFirewall: addFirewallReducer,
  // KMS Reducers
  addKMS: addKMSReducer,
  // Ingress Reducers
  addIngress: addIngressReducer,
  listIngress: listIngressReducer,
  ingressDetails: ingressDetailsReducer,
  // Cache Reducers
  tenantCache: tenantCacheSlice,
  // Console Reducers
  consoleSystem: consoleSystemReducer,
  console: consoleReducer,
  objectBrowser: objectBrowserReducer,
  bucketDetails: bucketDetailsReducer,
  addBucket: addBucketsReducer,
  createUser: createUserReducer,
  destination: destinationSlice,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(objectBrowserWSMiddleware(objectsWS)),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppState = ReturnType<typeof rootReducer>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
